import { DateTime } from 'luxon';
import React from 'react';
import { useIntl } from 'react-intl';

import Document from '@/components/legal/Document';
import Section from '@/components/legal/Section';
import Subsection from '@/components/legal/Subsection';

import messages from './messages';

const ShippingTerms = () => {
	const { formatMessage } = useIntl();

	return (
		<Document
			title={formatMessage(messages['0.0.0'])}
			lastChangedDate={DateTime.fromISO('2017-10-10').toLocaleString()}
		>
			<Section title={formatMessage(messages['1.0.0'])}>
				<Subsection title={formatMessage(messages['1.1.0'])}>
					{formatMessage(messages['legal.shipping.content.1.1.0'])}
				</Subsection>
				<Subsection title={formatMessage(messages['1.2.0'])}>
					{formatMessage(messages['legal.shipping.content.1.2.0'])}
				</Subsection>
				<Subsection title={formatMessage(messages['1.3.0'])}>
					<b>{formatMessage(messages['legal.shipping.country.unitedStates'])}</b>
					<ul>
						<li>
							<b>{formatMessage(messages['legal.shipping.domesticShipping.standardShipping'])} </b>
							{formatMessage(messages['legal.shipping.domesticShipping.standardShippingTime'])}
						</li>
						<li>
							<b>{formatMessage(messages['legal.shipping.domestic.priorityShipping'])} </b>
							{formatMessage(messages['legal.shipping.domestic.priorityShippingTime'])}
						</li>
					</ul>
					<b>{formatMessage(messages['legal.shipping.country.ukEuropeCanada'])}</b>
					<ul>
						<li>
							<b>{formatMessage(messages['legal.shipping.international.standardShipping'])} </b>
							{formatMessage(messages['legal.shipping.international.standardShippingTime'])}
						</li>
						<li>
							<b>{formatMessage(messages['legal.shipping.international.trackedShipping'])} </b>
							{formatMessage(messages['legal.shipping.international.trackedShippingTime'])}
						</li>
					</ul>
				</Subsection>
				<Subsection title={formatMessage(messages['1.4.0'])}>
					{formatMessage(messages['legal.shipping.content.1.4.0'])}
				</Subsection>
			</Section>
			<Section title={formatMessage(messages['2.0.0'])}>
				<Subsection>
					{formatMessage(messages['legal.shipping.content.2.1.0'], {
						calmStore: (
							<a href="mailto:store@calm.com?subject=Shipping Terms & Return Policy">store@calm.com</a>
						),
					})}
				</Subsection>
				<Subsection title={formatMessage(messages['2.2.0'])}>
					{formatMessage(messages['legal.shipping.content.2.2.0'])}
				</Subsection>
				<Subsection title={formatMessage(messages['2.3.0'])}>
					{formatMessage(messages['legal.shipping.content.2.3.0'])}
				</Subsection>
			</Section>
			<Section title={formatMessage(messages['3.0.0'])}>
				<Subsection>
					{formatMessage(messages['legal.shipping.content.3.1.0'], {
						calmStore: (
							<a href="mailto:store@calm.com?subject=Shipping Terms & Return Policy">store@calm.com</a>
						),
					})}
				</Subsection>
			</Section>
		</Document>
	);
};

export default ShippingTerms;
